import * as Variations from './Variations'
import { HtmlBuilder } from './HtmlBuilder'
import { EditorComponentContract } from '../EditorComponentContract'
import { SocialProofBubbleFactory } from '../../factories/SocialProofBubbleFactory'
export class SocialProofBubble extends EditorComponentContract {
  constructor() {
    super(Variations)
    this.factory = new SocialProofBubbleFactory
    this.htmlBuilder = HtmlBuilder
    this.pageComponent = true
  }

  elementIds() {
    return ['id']
  }

  elementClasses() {
    return ['classes', 'containerClasses']
  }

  elementContents() {
    return [
      'interval', 'withImage', 'filterBy', 'filterIds', 'message',
      'withVerified','showAsOffer','verifiedMessage','customOrders',
    ]
  }

  elementStyles() {
    return [
      {id: 'id', element: 'id', styles: 'styles', selector: '#', variation: null},
    ]
  }

  info() {
    return {
      name: 'SocialProofBubble',
      variations: this.variationsInfo()
    }
  }
}